/*
 * Renneway PDP Varyant Helper
 * ---------------------------
 * Urun detay sayfasinda variant secimini iyilestiriyor:
 *  1. COLLAPSE: bir option group icinde 6'dan fazla varyant varsa ilk 6'yi
 *     gosterip "+N daha goster" butonu ekler. Tekrar tikla -> "Daha az goster"
 *  2. AUTO-SCROLL: bir option secildiginde bir sonraki option grubuna smooth
 *     scroll + kisa pulse highlight (kullanici sonraki adimi fark etsin)
 *  3. GUIDANCE HINT: sonraki secilmesi gereken option grubunun ustunde
 *     "✓ Renk secildi — simdi Numara secin" gibi dinamik banner
 *
 * Hicbir Liquid'e dokunmuyor; sadece DOM uzerinde post-process. Theme'in
 * mevcut variant change logic'i bozulmaz (input degerleri ayni kalir,
 * "change" event'i normal fire eder).
 */
(function () {
  'use strict';

  var COLLAPSE_THRESHOLD = 6;     // 6'dan fazlaysa collapse
  var COLLAPSE_INITIAL = 6;       // baslangicta gosterilen sayi

  // Option name -> EN label (guidance + tooltip icin). Storefront ENG default.
  var OPTION_LABEL = {
    'color': 'Color', 'colour': 'Color', 'renk': 'Color',
    'number': 'Number', 'numara': 'Number', 'ne': 'Number',
    'size': 'Size', 'beden': 'Size',
    'composition': 'Composition', 'kompozisyon': 'Composition',
    'certificate': 'Certificate', 'sertifika': 'Certificate'
  };

  function labelFor(rawName) {
    if (!rawName) return rawName;
    var k = String(rawName).toLowerCase().trim();
    return OPTION_LABEL[k] || rawName;
  }

  function isColorOption(name) {
    if (!name) return false;
    var n = String(name).toLowerCase().trim();
    return n === 'color' || n === 'colour' || n === 'renk';
  }

  // Bir option group'unu process et: collapse + change handler + hint
  // Wrapper: optionset (variant-swatches) VEYA .product--options (color-swatches)
  function processOptionSet(wrapper, index, allSets) {
    if (wrapper.dataset.rnwHelperApplied) return;
    wrapper.dataset.rnwHelperApplied = '1';

    // Renneway: sertifika UI'si zaten gizli -> atla
    if (wrapper.classList.contains('cert-optionset-hidden')) return;
    if (wrapper.style.display === 'none') return;

    var ul = wrapper.querySelector('ul.product--variants-list');
    if (!ul) return;

    var items = Array.prototype.slice.call(ul.querySelectorAll('li.variant--item, li'));
    items = items.filter(function (li) { return li.querySelector('input'); });
    if (!items.length) return;

    var optName =
      wrapper.getAttribute('data-optionset') ||
      (wrapper.querySelector('.product--variants-title') ?
        wrapper.querySelector('.product--variants-title').textContent.split('|')[0].trim() : '') ||
      '';
    var enLabel = labelFor(optName);

    // 1) COLLAPSE — SADECE renk icin + esikten cok varsa.
    // CSS zaten nth-child(n+7)'yi gizliyor; biz fallback olarak inline
    // style.display'i de set ediyoruz (CSS cache miss durumu icin garanti).
    if (items.length > COLLAPSE_THRESHOLD && isColorOption(optName)) {
      var hiddenItems = items.slice(COLLAPSE_INITIAL);
      var hiddenCount = hiddenItems.length;

      function applyInlineHide(hide) {
        hiddenItems.forEach(function (li) {
          li.style.display = hide ? 'none' : '';
        });
      }
      // Baslangic: gizle
      applyInlineHide(true);

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'rnw-variant-toggle';
      toggle.setAttribute('data-expanded', 'false');
      var moreLabel = (window.rnwT && window.rnwT('variant.show_more', 'more')) || 'more';
      var lessLabel = (window.rnwT && window.rnwT('variant.show_less', 'Show less')) || 'Show less';
      toggle.innerHTML = '<span class="rnw-variant-toggle__text">+' + hiddenCount + ' ' + moreLabel + '</span>' +
                         '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';

      toggle.addEventListener('click', function () {
        var expanded = ul.classList.toggle('rnw-expanded');
        applyInlineHide(!expanded);
        toggle.querySelector('.rnw-variant-toggle__text').textContent =
          expanded ? lessLabel : '+' + hiddenCount + ' ' + moreLabel;
        toggle.setAttribute('data-expanded', expanded ? 'true' : 'false');
      });

      // Seçili li hidden index'teyse otomatik expand
      var hasHiddenChecked = hiddenItems.some(function (li) {
        var inp = li.querySelector('input[type="radio"],input[type="checkbox"]');
        return inp && inp.checked;
      });
      if (hasHiddenChecked) toggle.click();

      ul.insertAdjacentElement('afterend', toggle);
    }

    // 2) GUIDANCE BANNER — sadece *ilk olmayan* setlerde ekle
    if (index > 0) {
      var banner = document.createElement('div');
      banner.className = 'rnw-variant-guidance';
      banner.dataset.rnwGuidanceFor = optName;
      var nowSelectLabel = (window.rnwT && window.rnwT('variant.now_select', 'Now select')) || 'Now select';
      banner.innerHTML = '<span class="rnw-variant-guidance__icon">↓</span> ' +
                         '<span class="rnw-variant-guidance__text">' + nowSelectLabel + ' <strong>' + enLabel + '</strong></span>';
      wrapper.insertAdjacentElement('afterbegin', banner);

      // Bu set'te bir seçim varsa banner gizli olsun
      updateBannerVisibility(wrapper);
    }

    // 3) CHANGE HANDLER — bu set'te seçim olursa sonraki set'e scroll + bu setin banner'ini gizle
    ul.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"],input[type="checkbox"]')) return;
      updateBannerVisibility(wrapper);

      var nextSet = nextVisibleSet(wrapper, allSets);
      if (nextSet) {
        scrollToAndPulse(nextSet);
        updateBannerVisibility(nextSet);
      } else {
        scrollToQuantityIfFound(wrapper);
      }
    });
  }

  function nextVisibleSet(current, all) {
    var idx = all.indexOf(current);
    for (var i = idx + 1; i < all.length; i++) {
      if (all[i].classList.contains('cert-optionset-hidden')) continue;
      if (all[i].offsetParent === null) continue; // display:none
      return all[i];
    }
    return null;
  }

  function updateBannerVisibility(optset) {
    var banner = optset.querySelector('.rnw-variant-guidance');
    if (!banner) return;
    var anySelected = !!optset.querySelector('ul.product--variants-list input:checked');
    banner.style.display = anySelected ? 'none' : '';
  }

  function scrollToAndPulse(el) {
    try {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var headerOff = 90;   // ust header bosluk
      var bottomPad = 80;   // element altinda kalsin istedigimiz bosluk

      // Element zaten viewport'ta tamamen gorunuyorsa scroll'a gerek yok
      var topInView = rect.top >= headerOff;
      var bottomInView = rect.bottom <= (vh - bottomPad);
      if (topInView && bottomInView) {
        // sadece pulse calistir, scroll yok
      } else {
        // Hedef: element'in ALT kismi viewport altindan bottomPad uzakta olsun
        var targetY = window.scrollY + rect.bottom + bottomPad - vh;
        // Ama element'in top'u headerOff altindan asagi kaymasin (kucuk elementler icin)
        var minTargetY = window.scrollY + rect.top - headerOff;
        if (targetY > minTargetY) targetY = minTargetY;
        if (targetY < 0) targetY = 0;
        // Geriye scroll yapma (yukari kaydirma)
        if (targetY < window.scrollY - 4) targetY = window.scrollY;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    } catch (e) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    el.classList.remove('rnw-variant-pulse');
    void el.offsetWidth; // reflow -> animation restart
    el.classList.add('rnw-variant-pulse');
    setTimeout(function () { el.classList.remove('rnw-variant-pulse'); }, 2000);
  }

  function scrollToQuantityIfFound(refSet) {
    var form = refSet.closest('form');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"],[data-quantity-input],.product--quantity');
    if (!qty) return;
    var wrapper = qty.closest('.product--quantity, .product--qty-box, .product--actions') || qty;
    scrollToAndPulse(wrapper);
  }

  // renneway-chip listesi icin collapse (sadece color) + auto-scroll (tum step'lerde)
  function processRennewayChips() {
    var chipLists = document.querySelectorAll('.renneway-chips[data-renneway-chips]');
    Array.prototype.forEach.call(chipLists, function (list) {
      if (list.dataset.rnwChipsApplied) return;
      list.dataset.rnwChipsApplied = '1';

      var kind = list.getAttribute('data-renneway-chips') || '';
      var chips = Array.prototype.slice.call(list.querySelectorAll('.renneway-chip'));

      // 1) COLLAPSE — sadece "color" listesinde + esikten cok varsa.
      // Buton Liquid render time'da pre-rendered olabilir (data-rnw-prerender);
      // o varsa reuse et, yoksa yeni inject et.
      if (kind === 'color' && chips.length > COLLAPSE_THRESHOLD) {
        var hiddenChips = chips.slice(COLLAPSE_INITIAL);
        var hiddenCount = hiddenChips.length;

        function applyChipHide(hide) {
          hiddenChips.forEach(function (c) { c.style.display = hide ? 'none' : ''; });
        }
        applyChipHide(true);

        // Pre-rendered buton (Liquid'den) ara: list'in next sibling'i icinde
        var step = list.closest('.renneway-step');
        var toggle = step ? step.querySelector('.rnw-variant-toggle[data-rnw-prerender]') : null;
        var isPreRendered = !!toggle;

        var chipMoreLabel = (window.rnwT && window.rnwT('variant.show_more', 'more')) || 'more';
        var chipLessLabel = (window.rnwT && window.rnwT('variant.show_less', 'Show less')) || 'Show less';
        if (!toggle) {
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'rnw-variant-toggle';
          toggle.setAttribute('data-expanded', 'false');
          toggle.innerHTML = '<span class="rnw-variant-toggle__text">+' + hiddenCount + ' ' + chipMoreLabel + '</span>' +
                             '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
          list.insertAdjacentElement('afterend', toggle);
        }

        toggle.addEventListener('click', function () {
          var expanded = list.classList.toggle('rnw-expanded');
          applyChipHide(!expanded);
          toggle.querySelector('.rnw-variant-toggle__text').textContent =
            expanded ? chipLessLabel : '+' + hiddenCount + ' ' + chipMoreLabel;
          toggle.setAttribute('data-expanded', expanded ? 'true' : 'false');
        });

        // Aktif chip gizliyse otomatik expand
        var hasActiveHidden = hiddenChips.some(function (c) {
          return c.classList.contains('active') || c.classList.contains('is-selected') ||
                 c.getAttribute('aria-pressed') === 'true' || c.getAttribute('data-selected') === 'true';
        });
        if (hasActiveHidden) toggle.click();
      }

      // 2) CHIP CLICK -> sonraki step'e smooth scroll + pulse (tum chip listelerinde)
      list.addEventListener('click', function (e) {
        var chip = e.target.closest('.renneway-chip');
        if (!chip) return;
        setTimeout(function () {
          var currentStep = list.closest('.renneway-step');
          if (!currentStep) return;
          var nextStep = nextRennewayStep(currentStep);
          if (nextStep && !nextStep.hasAttribute('hidden') && nextStep.offsetParent !== null) {
            scrollToAndPulse(nextStep);
          }
        }, 80); // renneway-buy.js'in step'i visible yapmasi icin kisa bekleme
      });
    });
  }

  function nextRennewayStep(currentStep) {
    var next = currentStep.nextElementSibling;
    while (next) {
      if (next.classList && next.classList.contains('renneway-step')) {
        if (!next.hasAttribute('hidden') && next.offsetParent !== null) return next;
      }
      next = next.nextElementSibling;
    }
    return null;
  }

  function scan() {
    // 1. Shopify native optionset'ler (variant-swatches.liquid)
    var sets = Array.prototype.slice.call(document.querySelectorAll('optionset[data-optionset]'));
    var visible = sets.filter(function (s) {
      return !s.classList.contains('cert-optionset-hidden');
    });
    visible.forEach(function (s, i) { processOptionSet(s, i, visible); });

    // 2. Renneway custom chip step'leri (renneway-buy component)
    processRennewayChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // PDP AJAX ile yeniden render varsa observer
  var observer = new MutationObserver(function (muts) {
    var added = false;
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && (n.matches('optionset[data-optionset]') || n.matches('.renneway-chips[data-renneway-chips]'))) added = true;
        else if (n.querySelector && (
          n.querySelector('optionset[data-optionset]:not([data-rnw-helper-applied])') ||
          n.querySelector('.renneway-chips[data-renneway-chips]:not([data-rnw-chips-applied])')
        )) added = true;
      });
    });
    if (added) scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
